var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

var favicon = false;

function browserTabNotification() {
  // Favico is bundled inside assets/jquery.min.js (lines 3-30), not loaded as its
  // own file, so a jQuery version bump or CDN swap would remove it without warning.
  // Guard rather than throw a ReferenceError inside the shared document.ready.
  if (browserNotificationStatus && typeof Favico !== "undefined") {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});

/*
 * Is the browser actually on the cart page?
 *
 * This gates the whole file's behaviour. The cart-page branch binds the page
 * stepper handlers; the else branch binds the drawer handlers, including the
 * .Sd_addProduct intercept that performs every Layer 2 order-limit and
 * inventory-sync check.
 *
 * The test used to be pathname.indexOf("/cart") > -1, a substring match, so any
 * URL merely CONTAINING "/cart" took the cart-page branch: /products/carter-hoodie,
 * /products/cartography-club-tee, /pages/cartoon-night. On such a page the ATC
 * intercept never bound, the button fell back to a native form submit straight to
 * /cart/add, and Layer 2 was skipped silently for that product. The header cart
 * icon lost its handler there too. Latent rather than live, since it needs a
 * matching handle to exist, but nothing stops a club or product being named that
 * way and nothing would report it if one were.
 *
 * mainCartUrl is routes.cart_url from theme-scripts.liquid, so this stays correct
 * under a locale path prefix such as /en-au/cart. It is a top-level const in an
 * inline script earlier in the same snippet that loads this file with defer, so it
 * is always defined by the time this runs. Trailing slashes are normalised because
 * routes.cart_url has none while a visitor's URL may.
 */
function isCartPage() {
  try {
    var cartPath = new URL(mainCartUrl, window.location.origin).pathname.replace(/\/+$/, "");
    return window.location.pathname.replace(/\/+$/, "") === cartPath;
  } catch (e) {
    // Only reachable if mainCartUrl is malformed. Degrade to the old substring
    // behaviour rather than leaving every cart handler unbound.
    return window.location.pathname.indexOf("/cart") > -1;
  }
}

/*
 * Shared-pool total for a variant-inventory-sync product.
 *
 * Products tagged variant-inventory-sync share one stock pool across all their
 * variants, kept level by the SYNC_INVENTORY_ACROSS_VARIANTS Flow. Because every
 * variant reports the whole pool as its own stock, Shopify's native per-variant
 * check cannot see an over-commitment spread across several cart lines: a pool of
 * 3 accepts Small x3 AND Medium x3. Summing the lines that share a
 * data-sync-product-id is what catches it.
 *
 * qtyInputSelector differs per surface because the two carts use different
 * markup: '[name="updates[]"]' on the cart page, '.ajaxcart__qty-num' in the
 * drawer. The drawer keeps its own inline copy of this logic and is deliberately
 * left alone; it is the reference implementation this mirrors, per the spec's
 * non-goals.
 */
function syncPoolTotal(syncProductId, qtyInputSelector) {
  var total = 0;
  $(qtyInputSelector).each(function () {
    if ($(this).data("sync-product-id") === syncProductId) {
      total += parseInt($(this).val(), 10) || 0;
    }
  });
  return total;
}

/*
 * Layer 3 of order-limit enforcement, client side.
 *
 * main-cart.liquid and cart.jsonData.liquid compute a per-line allowance
 * (order_limit minus the quantity the same product holds on the cart's OTHER
 * lines) and emit it as data-limit-allowance on the quantity input and the plus
 * button. Both templates re-render after every change, so the Liquid-computed
 * allowance is authoritative; this check exists so that a single click cannot
 * exceed it in the window between renders.
 *
 * Returns false whenever no allowance is published, which is the case for every
 * product without an order_limit, so ordinary cart lines take no new code path.
 *
 * Only the plus buttons are guarded, by design: both templates mark the quantity
 * input readonly whenever a limit exists, so a limited line cannot be typed into
 * and the change handlers cannot raise its quantity.
 */
function exceedsLineAllowance($stepper, currentQty) {
  var raw = $stepper.data("limit-allowance");
  if (raw === undefined || raw === null || raw === "") return false;
  var allowance = parseInt(raw, 10);
  if (isNaN(allowance)) return false;
  return currentQty + 1 > allowance;
}

if (isCartPage()) {
  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        // if (quantity == 0) {
        //     $('[name="updates[]"][data-line="' + line + '"]').closest('tr').remove();
        // }
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          // $('[data-cart-form]').hide();
          // $('[data-cart-empty]').show();
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
          }
        }
        cartPageUpdate(cart);
      },
      error: function (XMLHttpRequest, textStatus) {
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          if (quantity == 0) {
            $('[name="updates[]"][data-line="' + line + '"]')
              .closest("tr")
              .remove();
          }
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          if (cart.item_count == 0) {
            // $('[data-cart-form]').hide();
            // $('[data-cart-empty]').show();
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          cartPageUpdate(cart);
        });
      },
    };
    jQuery.ajax(params);
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]'),
      $errorBox = $("#cartItemError-" + line);

    $errorBox.html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      if (exceedsLineAllowance($el, qty)) {
        $errorBox.html("You have reached the order limit for this product").show();
        parent.removeClass("disabled");
        parent.closest("[data-cart-items]").removeClass("disabled");
        return;
      }
      // Variant inventory sync check, mirroring the drawer's plus handler.
      var syncProductId = $el.data("sync-product-id");
      var variantInventoryLimit = $el.data("variant-inventory-limit");
      if (syncProductId && variantInventoryLimit !== undefined) {
        var poolTotal = syncPoolTotal(syncProductId, '[name="updates[]"]');
        if (poolTotal + 1 > parseInt(variantInventoryLimit, 10)) {
          $errorBox.html("Total stock limit is " + variantInventoryLimit + ".").show();
          parent.removeClass("disabled");
          parent.closest("[data-cart-items]").removeClass("disabled");
          return;
        }
        $errorBox.html("");
      }
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, "")),
      $errorBox = $("#cartItemError-" + line);
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $errorBox.html("");
    qty = validateQty(qty);

    // Variant inventory sync check, mirroring the drawer's change handler. The
    // changed field already holds its new value here, so the sum is the proposed
    // cart total and the comparison is > rather than the plus handler's + 1 > .
    var syncProductId = $el.data("sync-product-id");
    var variantInventoryLimit = $el.data("variant-inventory-limit");
    if (syncProductId && variantInventoryLimit !== undefined) {
      var poolTotal = syncPoolTotal(syncProductId, '[name="updates[]"]');
      if (poolTotal > parseInt(variantInventoryLimit, 10)) {
        $errorBox.html("Total stock limit is " + variantInventoryLimit + ".").show();
        // Restore the displayed quantity so it matches the cart, which was not
        // updated. Falls back to the most this line can hold when no previous
        // value was captured, same as the drawer.
        var prevQty = $el.data("prevQty");
        if (prevQty === undefined) {
          prevQty = Math.max(0, parseInt(variantInventoryLimit, 10) - (poolTotal - qty));
        }
        $el.val(prevQty);
        parent.removeClass("disabled");
        parent.closest("[data-cart-items]").removeClass("disabled");
        return;
      }
    }

    if (line) {
      changeCartItem(line, qty);
    }
  });

  // Remember each quantity field's value on focus so a rejected sync change
  // above can restore it, keeping the displayed quantity in step with the cart.
  // Mirrors the drawer's focusin handler.
  $(document).on("focusin", '[name="updates[]"]', function () {
    $(this).data("prevQty", $(this).val());
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0);
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    var $body = $(document.body),
      params = {
        type: "POST",
        url: cartChangeUrl,
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (cart.item_count == 0) {
            emptyCartStatus = true;
            $("[data-cart-count]").hide();
          } else {
            emptyCartStatus = false;
            $("[data-cart-count]").show();
          }
          var item = cart.items[line - 1];
          if (item) {
            $(
              '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
            ).val(item.quantity);
          }
          callback(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            callback(cart);
          });
        },
      };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    changeItem(line, qty, callback);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", async function (evt) {
      evt.preventDefault();
      $(this).addClass("disabled");
      $(this).attr("disabled", "disabled");
      let submit = $(this);
      let form = $(this).closest("form");
      if (submit.hasClass("Sd_addProductSticky")) {
        form = jQuery("#" + submit.attr("form"));
      }
      // When the button lives inside a .form-drawer that has been teleported to
      // document.body by form-drawer.js, closest("form") returns empty because the
      // drawer is no longer a descendant of the Shopify <form>. Recover the form
      // reference via the drawer's data-product-form-id attribute and serialize
      // inputs from the drawer itself (which holds the variant id, properties, etc).
      let formInputSource = form;
      if (!form.length) {
        let drawer = submit.closest(".form-drawer");
        if (drawer.length) {
          let recoveredId = drawer.data("product-form-id");
          if (recoveredId) {
            form = jQuery("#" + recoveredId);
          }
          formInputSource = drawer;
        }
      }
      let parentSection = form.closest(".shopify-section");
      let formObject = formInputSource.find(":input").serializeArray();
      let formValues = {};
      formObject.forEach((item) => {
        formValues[item.name] = item.value;
      });
      let productId = $(this).data("id");
      let orderLimit = $(this).data("limit");
      let formQuantity = formValues.quantity;
      // Re-enable the button on any early return so the customer can correct and retry.
      const reenableAddButton = () => {
        submit.removeClass("disabled is-loading").removeAttr("disabled");
      };
      // Show add-to-cart errors inline instead of a blocking native alert. The
      // sticky bar has its own .productErrors so the message is not off-screen.
      const showAddError = (msg) => {
        let box;
        if (submit.hasClass("Sd_addProductSticky")) {
          box = submit.closest(".yv-product-viewbar").find(".productErrors").first();
        }
        if (!box || !box.length) {
          box = parentSection.find(".productErrors").first();
        }
        if (box && box.length) {
          box.html(msg).show();
        } else {
          console.warn("[cart] " + msg);
        }
        var errorAnnouncer = document.querySelector('[data-atc-error-announce]');
        if (errorAnnouncer) {
          errorAnnouncer.textContent = '';
          setTimeout(function() { errorAnnouncer.textContent = msg; }, 0);
        }
      };
      let cart;

      if(productId){
        const cartResponse = await fetch("/cart.js");
        cart = await cartResponse.json();

        // Check if product already exists in cart.
        //
        // Only reachable for a club_event product with no order_limit, because
        // this whole block is behind if(productId) and product-form.liquid emits
        // data-id when `eventProduct or order_limit` but data-limit only when
        // order_limit. That is the intended rule: an event ticket is one per
        // cart, since the customer is booking a place rather than buying units.
        // It mirrors the server-side cart.items check in product-form.liquid and
        // exists as the client backstop for it, which matters because the
        // server-rendered gate can be stale in an already-rendered page.
        const isProductInCart = cart.items.some(
          (item) => item.product_id === parseInt(productId)
        );
        if (isProductInCart && !orderLimit) {
          showAddError('Item already in cart');
          reenableAddButton();
          return;
        }
        //tally the quantity of this product already in the cart
        const productCount = cart.items.reduce((acc, item) => {
          if (item.product_id === parseInt(productId)) {
            return acc + item.quantity;
          }
          return acc;
        }, 0);
        // Layer 2 of order-limit enforcement. custom.order_limit constrains how
        // many units go into ONE order, so the ceiling is what is already in this
        // cart plus what is being added now. Past orders are deliberately not
        // consulted: buying the product again in a later order is intended.
        //
        // This used to also fetch /cart?view=jsonOrders and add an orderCount
        // tally across the customer's whole order history, which was the lifetime
        // rule expressed in Layer 2. Both the fetch and the tally went with it, so
        // an add now costs one network request instead of two. The template that
        // served that route, templates/cart.jsonOrders.liquid, was deleted
        // 2026-08-11 once this was confirmed to be its only consumer; the route no
        // longer returns JSON, so do not reinstate the fetch expecting it to work.
        //
        // Do not reinstate a purchase-history read here. It would reimpose the
        // lifetime rule on Layer 2 alone and leave Layers 1 and 3 disagreeing with
        // it, which is the inconsistency theme_context.md Section 8 warns about.
        const requestedQty = parseInt(formQuantity, 10) || 1;
        if (orderLimit && productCount + requestedQty > orderLimit) {
          showAddError('You have reached the order limit for this product');
          reenableAddButton();
          return;
        }

      }

      // Variant Inventory Sync Logic
      let syncProductId = $(this).data("sync-product-id");
      let variantInventoryLimit = $(this).data("variant-inventory-limit");

      if (syncProductId && variantInventoryLimit !== undefined) {
          if (!cart) {
            const cartResponse = await fetch("/cart.js");
            cart = await cartResponse.json();
          }
          const quantityToAdd = parseInt(formValues.quantity || 1);
          
           const currentCartTotal = cart.items.reduce((acc, item) => {
              if (item.product_id === parseInt(syncProductId)) {
                  return acc + item.quantity;
              }
              return acc;
          }, 0);

          if (currentCartTotal + quantityToAdd > parseInt(variantInventoryLimit)) {
               let errorContainer = parentSection.find(".variant-sync-error");
               if (errorContainer.length === 0) {
                   // Fallback to standard error container if specific one not found
                   errorContainer = parentSection.find(".productErrors");
               }

               let msg = "You cannot add more of this item to your cart. Total stock limit is " + variantInventoryLimit + ".";
               errorContainer.html(msg).show();
               var syncErrorAnnouncer = document.querySelector('[data-atc-error-announce]');
               if (syncErrorAnnouncer) {
                 syncErrorAnnouncer.textContent = '';
                 setTimeout(function() { syncErrorAnnouncer.textContent = msg; }, 0);
               }

               // Re-enable button
               $(this).removeClass("disabled").removeAttr("disabled").removeClass("is-loading");
               return;
          } else {
               // Clear previous errors
               parentSection.find(".variant-sync-error").hide().html("");
          }
      }
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      var Email = $('input[data-attr="' + "email" + '"]').val();
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
      parentSection.find(".productErrors").hide().html("");
      submit.closest(".yv-product-viewbar").find(".productErrors").hide().html("");
      submit.addClass("is-loading");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }
      params = {
        type: "POST",
        url: cartAddUrl,
        data: formInputSource.is("form") ? formInputSource.serialize() : formInputSource.find(":input").serialize(),
        dataType: "json",
        success: function (line_item) {
          // Close any open form drawers before the cart drawer slides in
          if (window.FormDrawerController) {
            document.querySelectorAll('.form-drawer.is-open').forEach(function (d) {
              window.FormDrawerController.close(d.id);
            });
          }
          if (form.closest(".quick-add-popup").length > 0) {
            form.closest(".quick-add-popup")[0].classList.remove('show');
            form.closest("[quick-add-body]")[0].innerHTML = '';
            document.body.classList.remove('quick-add-popup-open');
          }
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }

          $("body").removeClass("quickview-open");
          if(document.getElementById('addToCartAlert')){
            document.getElementById('addToCartAlert').play();
          }
          var successAnnouncer = document.querySelector('[data-atc-success-announce]');
          if (successAnnouncer) {
            successAnnouncer.textContent = '';
            setTimeout(function() { successAnnouncer.textContent = 'Item added to cart'; }, 0);
          }
          if(hapticFeedbackStatus){
            const canVibrate = window.navigator.vibrate;
            if (canVibrate) window.navigator.vibrate(500);
          }
          // Dynamic form products (lazy form / wizard) close the drawer after
          // ATC and return focus to the opener; other products transition to
          // the cart in the same drawer.
          if (form.closest('[data-lazy-form], .wizard-container').length > 0 &&
              form.closest('.yv_side_drawer_wrapper').length > 0) {
            jQuery.getJSON(cartUrl, function (cart) {
              buildCart(cart, false);
              if (typeof closeSideDrawer === 'function') closeSideDrawer();
              setTimeout(function () { submit.removeClass('is-loading'); }, 1000);
            });
          } else {
            $("body").addClass("side_Drawer_open");
            jQuery.getJSON(cartUrl, function (cart, textStatus) {
              buildCart(cart, true);
              setTimeout(function () {
                submit.removeClass("is-loading");
              }, 1000);
            });
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.find(".productErrors");
            if (errorContainer.length > 0) {
              if(XMLHttpRequest.responseJSON.errors){
                let giftCardWrapper = form.find('[data-gift-card-box]');
                if(giftCardWrapper.length > 0 && XMLHttpRequest.responseJSON.errors['email']){
                    let errormessageWrapper = giftCardWrapper.find('[data-gift-card-errors]');
                    let giftCardEmail = giftCardWrapper.find('[type=email]');
                    errorContainer.html(giftCardEmail.attr('data-attr') +' '+  XMLHttpRequest.responseJSON.errors['email']).show();
                }
              }
              else{
                errorContainer.html(XMLHttpRequest.responseJSON.description).show();
              }
            }
          }
          setTimeout(function () {
            $(".Sd_addProductSticky").removeClass("is-loading");
            submit.removeClass("is-loading disabled");
          }, 1000);
        },
      };
      jQuery.ajax(params);
      setTimeout(function () {
        submit.removeAttr("disabled");
      }, 1000);
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        // Order limit check. Same allowance the cart page enforces; see
        // exceedsLineAllowance() for why only the plus button is guarded.
        if (exceedsLineAllowance($el, qty)) {
          let $limitErrorBox = $("#cartDrawerItemError-" + line);
          if ($limitErrorBox.length > 0) {
            $limitErrorBox.html("You have reached the order limit for this product").show();
          } else {
            console.warn("[cart] You have reached the order limit for this product");
          }
          parent.removeClass("disabled");
          parent.closest(".cart-items-wrapper").removeClass("disabled");
          return;
        }

        // Variant Inventory Sync Check
        let syncProductId = $el.data("sync-product-id");
        let variantInventoryLimit = $el.data("variant-inventory-limit");

        if (syncProductId && variantInventoryLimit !== undefined) {
             let totalQtyInCart = 0;
             let $qtyInputs = $(".ajaxcart__qty-num");
             let $errorBox = $("#cartDrawerItemError-" + line);
             // Sum quantities for all variants sharing this product sync ID
             $qtyInputs.each(function() {
                 if ($(this).data("sync-product-id") === syncProductId) {
                     let val = parseInt($(this).val()) || 0;
                     totalQtyInCart += val;
                 }
             });

             if (totalQtyInCart + 1 > parseInt(variantInventoryLimit)) {
                 // Show error
                 if ($errorBox.length > 0) {
                     $errorBox.html("Total stock limit is " + variantInventoryLimit + ".").show();
                 } else {
                     console.warn("[cart] Total stock limit is " + variantInventoryLimit + ".");
                 }

                 // Re-enable UI
                 parent.removeClass("disabled");
                 parent.closest(".cart-items-wrapper").removeClass("disabled");
                 return; // Stop execution
             } else {
                  // Clear error
                   if ($errorBox.length > 0) {
                     $errorBox.html("").hide();
                 }
             }
        }

        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      // Variant Inventory Sync Check
      let syncProductId = $el.data("sync-product-id");
      let variantInventoryLimit = $el.data("variant-inventory-limit");
      
      if (syncProductId && variantInventoryLimit !== undefined) {
           let totalQtyInCart = 0;
           let $qtyInputs = $(".ajaxcart__qty-num");
           let $errorBox = $("#cartDrawerItemError-" + line);
           // Sum quantities for all variants sharing this product sync ID
           $qtyInputs.each(function() {
               if ($(this).data("sync-product-id") === syncProductId) {
                   let val = parseInt($(this).val()) || 0;
                   totalQtyInCart += val;
               }
           });

           if (totalQtyInCart > parseInt(variantInventoryLimit)) {
                if ($errorBox.length > 0) {
                     $errorBox.html("Total stock limit is " + variantInventoryLimit + ".").show();
                } else {
                     console.warn("[cart] Total stock limit is " + variantInventoryLimit + ".");
                }

                // Reset the field to its previous value so the displayed quantity
                // matches the cart, which was not updated. Fall back to the maximum
                // this line can hold if no previous value was captured.
                let prevQty = $el.data("prevQty");
                if (prevQty === undefined) {
                  prevQty = Math.max(0, parseInt(variantInventoryLimit) - (totalQtyInCart - qty));
                }
                $el.val(prevQty);

                parent.removeClass("disabled");
                 parent.closest(".cart-items-wrapper").removeClass("disabled");
                return;
           } else {
               if ($errorBox.length > 0) {
                 $errorBox.html("").hide();
               }
           }
      }

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    // Remember each quantity field's value on focus so a rejected change above
    // can restore it, keeping the displayed quantity in sync with the cart.
    $(document).on("focusin", ".ajaxcart__qty-num", function () {
      $(this).data("prevQty", $(this).val());
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click ", ".cartDrawerNote", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });

    $(document).on("click", "[data-clear-cart]", function (evt) {
      evt.preventDefault();
      if (!confirm("Remove all items from your cart?")) return;
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function (cart) {
          buildCart(cart, false);
        },
      });
    });
  }

}

cartPageUpdate = function (cart) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      // $('body').find('[data-cart-items]').html($(result).find('[data-cart-items]').html());
      // $("body").find("[data-cart-items]").removeClass('disabled');
      // if (cart.item_count == 0) {
      //     emptyCartStatus = true;
      //     $('[data-cart-count').hide();
      //     $('.cart-section').find('a:first').trigger('focus');
      // } else {
      //     emptyCartStatus = false;
      //     $('body').find('[data-cart-items]').find('a:first').trigger('focus');
      // }
      // $('[data-cart-item-count]').text(cart.item_count);
      // $('[data-cart-original-price]').text(Shopify.formatMoney(cart.original_total_price, moneyFormat));
      // $('[data-cart-total-price]').text(Shopify.formatMoney(cart.total_price, moneyFormat));
      // if (cart.cart_level_discount_applications.length > 0) {
      //     var discounts = '';
      //     $.each(cart.cart_level_discount_applications, function(index, discount) {
      //         discounts += '<li data-cart-discount>Discount[' + discount.title + '] <strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong></li>';
      //     })
      //     $('li[data-cart-discount]').remove();
      //     $('li[data-cart-original]').removeClass('hidden');
      //     $(discounts).insertAfter('li[data-cart-original]')
      // } else {
      //     $('li[data-cart-original]').addClass('hidden');
      //     $('li[data-cart-discount]').remove();
      // }
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if(cartItemsCount > 0 && cartItemsCount < 100){
  $('[data-cart-count]').text(cart.item_count);
  }
  else{
    $('[data-cart-count]').text('');
  }
  var cartAnnouncer = document.querySelector('[data-cart-count-announce]');
  if (cartAnnouncer) {
    cartAnnouncer.textContent = cartItemsCount === 1 ? '1 item in cart' : cartItemsCount + ' items in cart';
  }
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function () {
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      if (element) {
        focusElement = element;
      }
      if (typeof syncSideDrawerA11y === 'function') syncSideDrawerA11y({ focus: true });
      if (typeof bindSideDrawerKeys === 'function') bindSideDrawerKeys();
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
  });
};

function updateBogoTierPrompt(promptEl, qty) {
  if (!promptEl) return;
  var tiersRaw = promptEl.getAttribute('data-bogo-tiers');
  if (!tiersRaw) return;
  var tiers;
  try { tiers = JSON.parse(tiersRaw); } catch (e) { return; }
  var nextTier = null;
  for (var i = 0; i < tiers.length; i++) {
    if (tiers[i].threshold > qty) { nextTier = tiers[i]; break; }
  }
  if (nextTier) {
    promptEl.textContent = 'Add ' + (nextTier.threshold - qty) + ' more ' + nextTier.message;
    promptEl.style.display = '';
  } else {
    promptEl.style.display = 'none';
  }
}

function updateBogoTierPromptsForProduct(productId) {
  var prompts = document.querySelectorAll('.cart-tier-prompt[data-bogo-product-id="' + productId + '"]');
  if (!prompts.length) return;
  var totalQty = 0;
  prompts.forEach(function (prompt) {
    var $input = $(prompt).closest('tr, .media-link').find('[name="updates[]"], .ajaxcart__qty-num').first();
    totalQty += $input.length ? (parseInt($input.val(), 10) || 0) : 0;
  });
  prompts.forEach(function (prompt) { updateBogoTierPrompt(prompt, totalQty); });
}

$(document).on('click', '.line_item_change, .ajaxcart__qty--plus, .ajaxcart__qty--minus', function () {
  var promptEl = $(this).closest('tr, .media-link').find('.cart-tier-prompt[data-bogo-product-id]')[0];
  if (!promptEl) return;
  updateBogoTierPromptsForProduct(promptEl.getAttribute('data-bogo-product-id'));
});

$(document).on('change', '[name="updates[]"], .ajaxcart__qty-num', function () {
  var promptEl = $(this).closest('tr, .media-link').find('.cart-tier-prompt[data-bogo-product-id]')[0];
  if (!promptEl) return;
  updateBogoTierPromptsForProduct(promptEl.getAttribute('data-bogo-product-id'));
});

